import { useCallback, useState } from 'react'
import { useShallowSelector } from 'components/WorkspaceEditor/Workspace2Store'
import { useCopyPasteShallowSelector } from '../store/CopyPasteStore'

const StatusText_Validating: string = 'Validating content, just a moment...'

export const usePasteProgressDialogState = () => {
    const [instanceId, setInstanceId] = useState<string>()
    const [progress, setProgress] = useState<number>(0)
    const [statusText, setStatusText] = useState<string>(StatusText_Validating)
    const [isPasteInProgress, setIsPasteInProgress] = useState<boolean>(false)
    const [warningText, setWarningText] = useState<string>()
    const [isWarningIgnored, setIsWarningIgnored] = useState<boolean>(false)

    const { setIsTreeLoading } = useShallowSelector((state) => ({
        setIsTreeLoading: state.actions.setIsTreeLoading,
    }))

    const { resetCopyPasteState } = useCopyPasteShallowSelector((state) => ({
        resetCopyPasteState: state.resetCopyPasteState,
    }))

    const handleCancel = useCallback(() => {
        setIsPasteInProgress(false)
        setIsTreeLoading(false)
        resetCopyPasteState()
    }, [resetCopyPasteState, setIsTreeLoading])

    const handleProceed = useCallback(() => {
        setWarningText('')
        setIsWarningIgnored(true)
        setIsPasteInProgress(false)
        resetCopyPasteState()
    }, [resetCopyPasteState])

    return {
        instanceId,
        setInstanceId,
        progress,
        setProgress,
        statusText,
        setStatusText,
        isPasteInProgress,
        setIsPasteInProgress,
        warningText,
        setWarningText,
        isWarningIgnored,
        setIsWarningIgnored,
        handleCancel,
        handleProceed,
    }
}